import { Controller } from '@hotwired/stimulus';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { SOCIAL_SHARE_CLICK } from 'components/analytics/conversions/constants/actions';

export default class SocialButtonsController extends Controller {
  trackFacebookShare(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: SOCIAL_SHARE_CLICK,
        label: 'Share-Facebook',
      },
    });
  }

  trackPinterestShare(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: SOCIAL_SHARE_CLICK,
        label: 'Share-Pinterest',
      },
    });
  }

  trackTwitterShare(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: SOCIAL_SHARE_CLICK,
        label: 'Share-Twitter',
      },
    });
  }

  trackEmailShare(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: SOCIAL_SHARE_CLICK,
        label: 'Share-Email',
      },
    });
  }
}
